const infoKamarColumn = [
    {
        colProps: {
            span: 8
        },
        title: 'Nama Kamar',
        key: 'nk'
    },
    {
        colProps: {
            span: 4
        },
        title: 'Jumlah TT',
        key: 'tt'
    },
    {
        colProps: {
            span: 4
        },
        title: 'Terpakai',
        key: 'tp'
    },
    {
        colProps: {
            span: 4
        },
        title: 'Tersedia',
        key: 'td'
    },
    {
        colProps: {
            span: 4
        },
        title: 'Tarif',
        key: 'tr'
    }
];

const infoKamarColumnTipe1 = [
    {
        colProps: {
            span: 4
        },
        title: 'Kelas',
        key: 'kk'
    },
    {
        colProps: {
            span: 4
        },
        title: 'Nama Kamar',
        key: 'nk'
    },
    {
        colProps: {
            span: 4
        },
        title: 'Jumlah TT',
        key: 'tt'
    },
    {
        colProps: {
            span: 4
        },
        title: 'Terpakai',
        key: 'tp'
    },
    {
        colProps: {
            span: 4
        },
        title: 'Tersedia',
        key: 'td'
    },
    {
        colProps: {
            span: 4
        },
        title: 'Tarif',
        key: 'tr'
    }
];

const JadwalDokterColumn = [
    {
        colProps: {
            span: 12
        },
        title: 'Nama Dokter',
        key: 'nd'
    },
    {
        colProps: {
            span: 4
        },
        title: 'Klinik',
        key: 'kk'
    },
    {
        colProps: {
            span: 4
        },
        title: 'Hari',
        key: 'hr'
    },
    {
        colProps: {
            span: 4
        },
        title: 'Jam',
        key: 'jm'
    }
];

const JadwalDokterColumn2 = [
    {
        colProps: {
            span: 6
        },
        title: 'Gambar',
        key: 'gd'
    },
    {
        colProps: {
            span: 6
        },
        title: 'Nama Dokter',
        key: 'nd'
    },
    {
        colProps: {
            span: 4
        },
        title: 'Klinik',
        key: 'kk'
    },
    {
        colProps: {
            span: 4
        },
        title: 'Hari',
        key: 'hr'
    },
    {
        colProps: {
            span: 4
        },
        title: 'Jam',
        key: 'jm'
    }
];
// glagah server : http://192.168.0.8:8003/index.php/
// mojosari server : 'http://192.168.0.10:9999/'
const base_url = process.env.REACT_APP_API_URL;
const websocket = 'ws://localhost:8080';
const urlKamar = base_url+'kamar';
const urlJadwal = base_url+'infojadwal';
const urlHeaderData = base_url+'homedata';
const urlChangeSetting = base_url+'config/change';
const urlGetSetting = base_url+'config/get';

export {
    infoKamarColumn,
    JadwalDokterColumn,
    urlKamar,
    urlJadwal,
    urlHeaderData,
    JadwalDokterColumn2,
    infoKamarColumnTipe1,
    urlChangeSetting,
    urlGetSetting,
    websocket,
}